import { render, staticRenderFns } from "./EbookHome.vue?vue&type=template&id=61e433c7&scoped=true"
import script from "./EbookHome.vue?vue&type=script&lang=js"
export * from "./EbookHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e433c7",
  null
  
)

export default component.exports